import { useState } from "react";
import styles from "./Footer.module.css";
import QrCodeModal from "../QrCodeModal/QrCodeModal";

export default function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <footer className={styles.footer}>
        <span className={styles.text}>
          © {new Date().getFullYear()} ArtLogica
        </span>

        <button
          className={styles.qrButton}
          onClick={() => setIsModalOpen(true)}
        >
          Gerar QR Code
        </button>
      </footer>

      {isModalOpen && (
        <QrCodeModal onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
}
